<template>
  <div>
    <CCard>
      <CCardHeader>
        <span class="font-weight-bold">
          <CIcon name="cilStar" />
          Danh sách cửa hàng
        </span>
        <CButton
          color="success"
          size="sm"
          class="float-right"
          v-if="isAdmin"
          @click.prevent="
            (e) => {
              editing = true;
              agencyId = 0;
            }
          "
        >
          <CIcon name="cil-plus" />
          Thêm cửa hàng
        </CButton>
      </CCardHeader>
      <CCardBody>
        <CRow>
          <CCol md="4">
            <CSelect
              label="Trạng thái"
              placeholder="Trạng thái"
              :value.sync="agencyStatus"
              :options="
                Object.keys(statusList).map((_) => {
                  return {
                    value: _,
                    label: statusList[_],
                  };
                })
              "
              :horizontal="{
                label: 'col-4 text-right',
                input: 'col-8',
              }"
            />
          </CCol>
          <CCol md="4">
            <CInput
              label="Tên cửa hàng"
              placeholder="Tên cửa hàng"
              v-model="agencyName"
              :horizontal="{
                label: 'col-4 text-right',
                input: 'col-8',
              }"
              @keyup.enter="doFilter"
            />
          </CCol>
          <CCol md="3" class="text-center">
            <CButton color="primary" class="mr-2 mb-3" @click="doFilter">
              <CIcon name="cil-search" custom-classes="c-icon m-0" />
              Tìm kiếm
            </CButton>

            <CButton color="secondary" class="mb-3" @click="clear">
              <CIcon name="cil-x-circle" custom-classes="c-icon m-0" />
              Đặt lại
            </CButton>
          </CCol>
        </CRow>
        <odata-table
          ref="lstAgency"
          url="odata/Agency"
          :filter="filter"
          select="Id,Name,Address,AgencyType,Status,CreatedAt"
          sortBy="CreatedAt desc"
          :pageSize="pageSize"
          :colSetting="{
            Action: {
              display: '#',
              sortable: false,
              style: 'min-width: 50px;',
            },
            Name: {
              field: 'Name',
              display: 'Tên cửa hàng',
              sortable: true,
              style: 'min-width: 150px',
            },
            Address: {
              field: 'Address',
              display: 'Địa chỉ',
              sortable: true,
              style: 'min-width: 200px',
            },
            AgencyType: {
              field: 'AgencyType',
              display: 'Loại hình',
              sortable: true,
              style: 'min-width: 120px',
            },
            Status: {
              field: 'Status',
              display: 'Trạng thái',
              sortable: true,
              style: 'min-width: 100px',
            },
            CreatedAt: {
              field: 'CreatedAt',
              display: 'Ngày tạo',
              sortable: true,
              style: 'min-width: 120px',
            },
          }"
        >
          <template v-slot:tbody="{ rows }">
            <tr v-for="(row, i) in rows" :key="`tr-${i}`">
              <td>{{ i + 1 + ($refs.lstAgency.page - 1) * pageSize }}.</td>
              <td>
                <a
                  href="javascript:"
                  class="text-primary"
                  :title="`Cập nhật: ${row.Name}`"
                  @click="
                    (e) => {
                      agencyId = row.Id;
                      editing = true;
                    }
                  "
                >
                  <CIcon name="cil-pencil" />
                  {{ row.Name }}
                </a>
              </td>
              <td class="text-truncate" style="max-width:200px;">
                <span :title="row.Address">
                  {{ row.Address }}
                </span>
              </td>
              <td>
                {{ $const.AGENCY_TYPES_TEXT[row.AgencyType] }}
              </td>
              <td>
                <CBadge :color="getBadge(row.Status)">
                  {{ $const.STATUS_TEXT[row.Status] }}
                </CBadge>
              </td>
              <td>
                {{
                  $moment
                    .utc(row.CreatedAt)
                    .local()
                    .format("DD/MM/YY HH:mm")
                }}
              </td>
            </tr>
          </template>
        </odata-table>
      </CCardBody>
    </CCard>
    <detail
      :editing.sync="editing"
      :agencyId.sync="agencyId"
      @reload="$refs.lstAgency.loadData()"
    />
  </div>
</template>

<script>
import odataTable from "@/components/odataTable.vue";
import detail from "./Detail.vue";

export default {
  name: "Agency",
  components: {
    odataTable,
    detail,
  },
  data() {
    return {
      editing: false,
      agencyId: 0,
      pageSize: 10,
      agencyStatus: this.$const.STATUS.Active.toString(),
      statusList: this.$const.STATUS_TEXT,
      agencyName: null,
      filters: null,
    };
  },
  computed: {
    filter() {
      let filters = [];

      if (this.filters && this.filters.length) {
        filters = [...this.filters];
      }

      return filters.join(" and ");
    },
    isAdmin() {
      let authUser = this.$user.getters.authUser;
      return authUser
        ? authUser && authUser.role == this.$const.ROLES.SuperAdmin
        : false;
    },
  },
  methods: {
    getBadge(status) {
      switch (status) {
        case this.$const.STATUS.Active:
          return "success";
        case this.$const.STATUS.InActive:
          return "secondary";
        default:
          "primary";
      }
    },
    doFilter() {
      let filters = [];
      this.agencyStatus && filters.push(`Status eq ${this.agencyStatus}`);
      this.agencyName && filters.push(`contains(Name,'${this.agencyName}')`);
      filters.join(" and ");

      if (JSON.stringify(this.filters) != JSON.stringify(filters)) {
        this.filters = filters;
      } else {
        this.$refs.lstAgency.loadData();
      }
    },
    clear() {
      this.agencyStatus = this.$const.STATUS.Active.toString();
      this.agencyName = null;
    },
  },
};
</script>
